export default __webpack_public_path__ + "static/media/Header.e638f208.gif";